<template>
    <f7-page name="beneficiary-list" @page:afterin="afterin">
        <f7-navbar class="view-mobile no-border">
            <f7-nav-left class="back-button">
                <f7-link icon-f7="chevron_left" @click="goHome" color="black"></f7-link>
            </f7-nav-left>
            <f7-nav-right></f7-nav-right>
        </f7-navbar>

        <div class="block">
            <f7-row class="b mt-xl mb-md">{{$t('beneficiary-my-recipient')}}</f7-row>
        </div>
        <f7-block>
            <beneListComponent :isSearchBar="true" :isCreateBene="true" />

            <f7-button class="mb-sm view-desktop mt-xxl" large fill @click="addBeneficiary()">
                <span>{{$t('beneficiary-btn-add')}}</span>
            </f7-button>
        </f7-block>

        <f7-toolbar position="bottom" no-hairline class="toolbar-with-button view-mobile">
            <f7-button @click="addBeneficiary()" class="mb-sm" large fill>
                {{$t('beneficiary-btn-add')}}
            </f7-button>
        </f7-toolbar>
    </f7-page>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import store from '../../store'
    // import beneListComponent from '@/components/beneficiary-list-1'

    export default {
        data() {
            return {
            }
        },
        computed: {
            ...mapGetters('auth', [
                'authenticating',
                'authenticationError',
                'authenticationErrorCode',
                'authenticationSuccess'
            ])
        },
        components: {
            beneListComponent: () => import('@/components/beneficiary-list-1')
        },
        mounted() {
            // Required for everypage. Toggle desktop-view footer.
            this.toggleFooterVisibility(false)
            this.$f7.$('.page-content').on('scroll', (e) => {
                this.toggleFooterVisibility(e.target)
            })
        },
        methods: {
            ...mapActions('auth', ['login']),
            
            afterin(){
                window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
            },
            async addBeneficiary() {
                store.state.beneficiary.routerTo = 'beneList';
                store.state.beneficiary.isCreateBeneficiary = true;
                this.$f7router.navigate("/beneficiary-new-details");
            },

            goHome() {
                this.$f7router.navigate("/home");
            },
        }
    }
</script>
